













import { useAuth, useCart, useUser } from '@checkout/composables';
import { useCheckoutStore } from '@checkout/stores';
import Header from '@checkout-organisms/header/Header.vue';
import {
  defineComponent,
  onMounted,
  useContext,
  useRoute
} from '@nuxtjs/composition-api';
import { onSSR } from '@vue-storefront/core';
import { storeToRefs } from 'pinia';

import ErrorBoundary from '~/components/ErrorBoundary/ErrorBoundary.vue';
import type { Customer } from '~/composables';
import { useConfig } from '~/composables';
import VaimoLoader from '~/diptyqueTheme/components/atoms/VaimoLoader.vue';
import { useGoogleTagManager, useIPData } from '~/diptyqueTheme/composable';
import { useErrorLayoutStatusStore } from '~/diptyqueTheme/stores/error';

export default defineComponent({
  name: 'CheckoutLayout',
  components: {
    ErrorBoundary,
    Notification: () => import('~/diptyqueTheme/components/Notification.vue'),
    VaimoLoader,
    Header
  },
  setup() {
    const {
      app: { $gtm, i18n }
    } = useContext();
    const { load: loadStoresConfig, config: configStore } = useConfig();
    const { cart } = useCart();
    const { getBeginCheckoutDetails } = useGoogleTagManager();
    const checkoutStore = useCheckoutStore();
    const { isPageLoading } = storeToRefs(checkoutStore);
    const { getCountryCodeByIP, userCountry } = useIPData();
    const langClass = 'lang-' + i18n.localeProperties.code;

    onSSR(async () => {
      const storeConfig = configStore.value;

      if (!storeConfig || Object.keys(storeConfig).length === 0) {
        await loadStoresConfig();
      }
    });

    const errorLayoutStatusStore = useErrorLayoutStatusStore();
    const { getPageviewDetails, EVENT_TIMEOUT } = useGoogleTagManager();
    const { isAuthenticated } = useAuth();
    const { user } = useUser();
    const route = useRoute();

    const pushGtmPageview = () => {
      const statusCode =
        errorLayoutStatusStore.getErrorStatusCode()?.toString() ?? null;
      const pageviewDetails = getPageviewDetails(
        user.value as unknown as Customer,
        isAuthenticated.value,
        route.value,
        statusCode
      );

      if (pageviewDetails) {
        setTimeout(() => {
          $gtm.push(pageviewDetails);
        }, EVENT_TIMEOUT);
      }
    };

    onMounted(async () => {
      if (!userCountry.value) {
        await getCountryCodeByIP();
      }

      pushGtmPageview();
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore cart value has all necessary data for getBeginCheckoutDetails
      $gtm.push(getBeginCheckoutDetails(cart.value));
    });

    return {
      isPageLoading,
      langClass
    };
  }
});
